// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TxUp","label":"styles_label__3qOE6"};